import { MessageCircle, Phone } from "lucide-react";
import { PHONE_TEL, WA_LINK } from "../lib/site";

export default function StickyBar() {
    return (
        <div
            className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-3 border-t border-white/10 bg-bitume/90 backdrop-blur-xl"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            data-testid="mobile-sticky-cta"
        >
            <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="sticky-whatsapp"
                className="flex flex-col items-center justify-center gap-1 bg-wa text-bitume font-semibold text-[11px] py-3.5"
            >
                <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
                WhatsApp
            </a>
            <a
                href={`tel:${PHONE_TEL}`}
                data-testid="sticky-call"
                className="flex flex-col items-center justify-center gap-1 bg-azure text-cloud font-semibold text-[11px] py-3.5"
            >
                <Phone className="w-5 h-5" strokeWidth={2.2} />
                Chiama ora
            </a>
            <a
                href="#contatti"
                data-testid="sticky-quote"
                className="flex flex-col items-center justify-center gap-1 bg-ambra text-bitume font-semibold text-[11px] py-3.5"
            >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8m8 4H8"/></svg>
                Preventivo
            </a>
        </div>
    );
}
